import { userAxios } from '../../index'

/**
 * Revisión de garantías. Permiso membership-guarantee.review (superadmin).
 */

/** GET /api/membership-guarantees */
const list = async ({ status, perPage } = {}) => {
  const params = {}
  if (status) params.status = status
  if (perPage) params.per_page = perPage
  const response = await userAxios.get('membership-guarantees', { params })
  return response.data
}

/** GET /api/membership-guarantees/{id} */
const detail = async id => {
  const response = await userAxios.get(`membership-guarantees/${id}`)
  return response.data
}

/** POST /api/membership-guarantees/{id}/approve */
const approve = async (id, notes) => {
  const body = {}
  if (notes && String(notes).trim()) body.notes = String(notes).trim()
  const response = await userAxios.post(`membership-guarantees/${id}/approve`, body)
  return response.data
}

/** POST /api/membership-guarantees/{id}/reject. Las notas son obligatorias. */
const reject = async (id, notes) => {
  const response = await userAxios.post(`membership-guarantees/${id}/reject`, {
    notes: String(notes || '').trim(),
  })
  return response.data
}

/** POST /api/membership-guarantees/{id}/retry */
const retry = async id => {
  const response = await userAxios.post(`membership-guarantees/${id}/retry`)
  return response.data
}

export default {
  list,
  detail,
  approve,
  reject,
  retry,
}
